export default {
    COOKIES_STORAGE_PROPS: {
        credentialsDomain: typeof window === 'undefined' ? '' : window.location.hostname,
        secure: false,
        path: '/',
        sameSite: undefined,
    },
};
//# sourceMappingURL=cookies.constants.js.map